var memoryStore = {};

function setItem(key, val) {
  memoryStore[key] = val;
}

function getItem(key) {
  return memoryStore[key] || null;
}

function removeItem(key) {
  delete memoryStore[key];
}

var memoryStorage = {
  setItem: setItem,
  getItem: getItem,
  removeItem: removeItem
};
export default memoryStorage;
//# sourceMappingURL=memory-storage.js.map